import { render, staticRenderFns } from "./EwaGroup.vue?vue&type=template&id=4ad3c24c"
import script from "./EwaGroup.vue?vue&type=script&lang=js"
export * from "./EwaGroup.vue?vue&type=script&lang=js"
import style0 from "./EwaGroup.vue?vue&type=style&index=0&id=4ad3c24c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports